import { render, staticRenderFns } from "./FormatPageOrderTool.vue?vue&type=template&id=ad10eae2&scoped=true&"
import script from "./FormatPageOrderTool.vue?vue&type=script&lang=ts&"
export * from "./FormatPageOrderTool.vue?vue&type=script&lang=ts&"
import style0 from "./FormatPageOrderTool.vue?vue&type=style&index=0&id=ad10eae2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad10eae2",
  null
  
)

export default component.exports